import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const AdminNavabar = () => {
  const navigate = useNavigate();

  const logoutUser = (event) => {
    localStorage.removeItem("esd_access_token");
    localStorage.removeItem("esd_user_id");
    navigate("/");
  };

  return (
    <nav
      className="navbar is-light"
      role="navigation"
      aria-label="main navigation"
    >
      <div className="container">
        <div className="navbar-brand">
          <Link className="navbar-item" to="/dashboard">
            <img
              src="/assets/logo.png"
              alt="Kodi"
              style={{ maxHeight: "2.50rem" }}
            />
            &nbsp; <b>Kodi</b>
          </Link>

          <Link
            to="/dashboard"
            role="button"
            className="navbar-burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </Link>
        </div>

        <div id="navbarBasicExample" className="navbar-menu">
          <div className="navbar-start">
            <Link to="/dashboard" className="navbar-item">
              Dashboard
            </Link>

            <Link to="/documenation" className="navbar-item">
              Documentation
            </Link>

            <Link to="/struts-ai" className="navbar-item">
              Struts AI
            </Link>

            {/* <div className="navbar-item has-dropdown is-hoverable">
              <Link to="/" className="navbar-link">
                More
              </Link>

              <div className="navbar-dropdown">
                <Link to="/about" className="navbar-item">
                  About
                </Link>
                <Link to="/contact" className="navbar-item">
                  Contact
                </Link>
              </div>
            </div> */}
          </div>
          <div className="navbar-end">
            <div className="navbar-item">
              <div className="buttons">
                <button className="button is-primary" onClick={logoutUser}>
                  <strong>Log Out</strong>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavabar;
